import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import OperatorApplicationStatus from "../operator/Request-status";
import IdentificationStatus from "../operator/Identification-request-status";
import "./gsc-operators-search.css";

type TabType = "application" | "identification";

const OperatorRequestStatusPage: FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>("application");
  const navigate = useNavigate();

  return (
    <div className="request-status-page">
      <div className="request-status-tabs">
        <button
          type="button"
          className={
            activeTab === "application"
              ? "request-status-tab active"
              : "request-status-tab"
          }
          onClick={() => setActiveTab("application")}
        >
          Статус заявки
        </button>

        <button
          type="button"
          className={
            activeTab === "identification"
              ? "request-status-tab active"
              : "request-status-tab"
          }
          onClick={() => setActiveTab("identification")}
        >
          Идентификация
        </button>

        <button
          type="button"
          className="request-status-tab"
          onClick={() => navigate("/operator/developer-tickets")}
        >
          Технический отдел
        </button>
      </div>

      <div className="request-status-content">
        {activeTab === "application" && <OperatorApplicationStatus />}

        {activeTab === "identification" && <IdentificationStatus />}
      </div>
    </div>
  );
};

export default OperatorRequestStatusPage;
